import { Box, Typography } from "@mui/material";
import { DateTimePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { useDispatch, useSelector } from "react-redux";
import { setSignedDate } from "../../../lib/redux/slices/signedDateSlice";
import { useLocation } from "react-router-dom";

const useStyle = {
  datePickerStyle: {
    width: "100%",
    "&.MuiFormControl-root .MuiInputBase-root": {
      borderRadius: "4px",
      backgroundColor: "#d4ecff87",
    },
  },
};

const SetSignedDate = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const { signedDate } = useSelector((state) => state.signedDateReducer);

  const isDetailPage = location.pathname === "/prospect-details";

  return (
    <Box mt={2} mb={5}>
      <Typography variant="h6" color={"text.charcoalGrey"}>
        Contract Signed Date
      </Typography>

      <Box width={{ md: "23.333%" }}>
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <DateTimePicker
            sx={useStyle.datePickerStyle}
            value={signedDate}
            // disablePast={true}
            onChange={(newValue) => dispatch(setSignedDate(newValue))}
            format="DD.MM.YY [at] HH:mm a"
            readOnly={isDetailPage}
          />
        </LocalizationProvider>
      </Box>
    </Box>
  );
};

export default SetSignedDate;
